"use strict";
// models/menuButtons.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.supprimerButton = exports.dupliquerButton = exports.ajouterButton = void 0;
const globals_1 = require("models/globals");
exports.ajouterButton = {
    view: "button", id: "button-add", type: "icon",
    icon: "mdi mdi-plus", value: (0, globals_1._)("Ajouter"), width: 140, hidden: true
};
exports.dupliquerButton = {
    view: "button", id: "button-dup", type: "icon", hidden: true,
    icon: "mdi mdi-content-duplicate", value: (0, globals_1._)("Dupliquer"), width: 140
};
exports.supprimerButton = {
    view: "button", value: (0, globals_1._)("Supprimer"), width: 140, hidden: true,
    type: "icon", id: "button-del",
    icon: "mdi mdi-delete-forever-outline"
};
